import React, { useState } from 'react';
import Modal from 'react-modal';
import DropDown from './DropDown';
import '../../style/dropdown.css';

export default function FoldNav(props){

    const [modalOpen, setModalOpen] = useState(false);

    const customStyles = {
        content : {
            top                   : '0',
            left                  : '0',
            right                 : 'auto',
            bottom                : 'auto',
            backgroundColor       : 'hsl(136, 65%, 51%)',
            color                  : 'white',
            width                 :  '100%',
            margin: '0 auto'
        }
    }

    function show(){
        setModalOpen(true);
    }
    function close(){
        setModalOpen(false);
    }

return(
    <>
     <div className={props.className} onClick={show}>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <Modal isOpen={modalOpen} onRequestClose={close} style={customStyles}>
        <input type="submit" value="x" onClick={close} className="close"/>
        <DropDown />
    </Modal>

    </>
   
)
}